import React from 'react';
import { useIntl } from 'react-intl';
import { WithStylesProps } from 'react-jss';

import { EM_DASH } from '~/common/constants/unicode';
import EcInput from '~/components/Shared/EcInput/EcInput';

import styles from '../InformationField.styles';
import { Field } from '../InformationFieldV2';

interface StringFieldProps extends WithStylesProps<typeof styles> {
  field: Field;
  editMode: boolean;
  fieldValue: any;
  setFieldValue: (value: any) => void;
}

export const StringField = ({
  classes,
  field,
  editMode,
  fieldValue,
  setFieldValue,
}: StringFieldProps) => {
  const intl = useIntl();

  if (editMode) {
    const presentValue = fieldValue ? fieldValue.value : '';

    return (
      <div className={classes.editItemContainer}>
        <EcInput
          id={`string-field-${field.id}`}
          ariaLabel={field.name}
          input={{
            value: presentValue,
            onChange: (event: any) =>
              setFieldValue({
                display_value: event.target.value,
                value: event.target.value,
              }),
          }}
          placeholder={intl.formatMessage(
            {
              id: 'InformationField.enterFieldPlaceholder',
              defaultMessage: 'Enter {fieldName}',
              description:
                'Placeholder text for string input field. Example: fieldName = "Contract Title"',
            },
            { fieldName: field.name },
          )}
          width="100%"
          isDisabled={!field.is_editable}
        />
      </div>
    );
  }

  return !fieldValue || fieldValue.display_value === ''
    ? EM_DASH
    : fieldValue.display_value;
};
